import { GameObjectReference } from "@shared/types";
import styles from "../../styles";
import { GameRouteService } from "../../services/GameRouteService";

export class AchievementItemComponent {
    private readonly _object: GameObjectReference;

    public constructor(object: GameObjectReference) {
        this._object = object;
    }

    private async createPopup(): Promise<HTMLElement> {
        const popupOverlay: HTMLDivElement = document.createElement("div");
        popupOverlay.className = "achievement-popup-overlay";

        const styleElement: HTMLStyleElement = document.createElement("style");
        styleElement.textContent = styles.achievement;
        popupOverlay.appendChild(styleElement);

        const popup: HTMLDivElement = document.createElement("div");
        popup.className = "achievement-popup";

        const image: HTMLImageElement = document.createElement("img");
        image.src = this._object.image ?? "../assets/img/items/lighter.png";
        image.alt = this._object.name;

        const name: HTMLHeadingElement = document.createElement("h2");
        name.innerText = this._object.name;

        const time: HTMLParagraphElement = document.createElement("p");
        const gameRouteService: GameRouteService = new GameRouteService();
        const playerName: string = localStorage.getItem("playerName")!;
        const values: [number, number, number] = await gameRouteService.getTimePlayer(this._object.alias, playerName);
        if (values[1] < 10) {
            time.innerText = `Achieved in: ${values[0]}:0${values[1]} minutes \n That puts you ${values[2]}`;
        }
        else {
            time.innerText = `Achieved in: ${values[0]}:${values[1]} minutes \n That puts you ${values[2]}`;
        }

        const achievedText: HTMLParagraphElement = document.createElement("p");
        achievedText.innerText = "This achievement has been achieved.";
        achievedText.style.marginTop = "8px";
        achievedText.style.color = "#aaa";

        const closeBtn: HTMLButtonElement = document.createElement("button");
        closeBtn.innerText = "Close";
        closeBtn.onclick = () => popupOverlay.remove();

        popup.appendChild(image);
        popup.appendChild(name);
        popup.appendChild(time);
        popup.appendChild(achievedText);
        popup.appendChild(closeBtn);

        popupOverlay.appendChild(popup);
        return popupOverlay;
    }

    public createElement(): HTMLElement {
        const achievementItem: HTMLDivElement = document.createElement("div");
        achievementItem.className = "achievement-item";

        const styleElement: HTMLStyleElement = document.createElement("style");
        styleElement.textContent = styles.achievement;
        achievementItem.appendChild(styleElement);

        if (!this._object.achieved) {
            achievementItem.style.filter = "grayscale(100%)";
            achievementItem.style.opacity = "0.7";
        }

        const image: HTMLImageElement = document.createElement("img");
        image.src = this._object.image ?? "../assets/img/items/lighter.png";
        image.alt = this._object.name;
        image.width = 64;
        image.height = 64;

        const name: HTMLSpanElement = document.createElement("span");
        name.innerText = this._object.name;

        const hoverOverlay: HTMLDivElement = document.createElement("div");
        hoverOverlay.className = "achievement-hover-overlay";

        achievementItem.appendChild(image);
        achievementItem.appendChild(name);

        if (this._object.achieved) {
            achievementItem.appendChild(hoverOverlay);

            achievementItem.onclick = async () => {
                const popup: HTMLElement = await this.createPopup();
                document.body.appendChild(popup);
            };
        }

        return achievementItem;
    }
}
